import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import Container from '@mui/material/Container'
import setRedirectUrl from '../../redux/actions/redirection/setRedirectUrl'
import { Paper, useMediaQuery, useTheme } from '@mui/material'
import FormLocales from './components/Form'
import SoloLectura from './components/SoloLectura'
import setLogged from '../../redux/actions/logged/setLogged'
import AlertDialog from '../../components/Common/Dialog'
import Navbar from '../../components/Navbar'
import Footer from '../Home/components/Footer'
import useLocal from '../Products/hooks/locals.hook'
import { useNavigate } from 'react-router'
import DialogContactoSoporte from '../../components/Common/DialogContactoSoporte'

const AbmLocalPage: React.FC = (props: any) => {
  const { userLogged } = props.logged
  const { codLocal } = userLogged
  const { local, fetchData, loading: loadingLocal } = useLocal(codLocal)
  const [soloLectura, setSoloLectura] = useState<boolean>(true)
  const [loading, setLoading] = useState<boolean>(false)
  const [showContactoSoporte, setShowContactoSoporte] = useState<boolean>(false)
  const [codeSoporte, setCodeSoporte] = useState<string>(null)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const navigate = useNavigate()

  const handleShowContactoSoporte = (cod: string) => {
    setCodeSoporte(cod)
    setShowContactoSoporte(true)
  }

  const contactoSoporteDialog = (
    <DialogContactoSoporte
      open={showContactoSoporte}
      codLocal={codeSoporte}
      setCode={setCodeSoporte}
      closable={false}
      onContactar={() => {
        setShowContactoSoporte(false)
        navigate('/abm-products')
      }}
    />
  )

  if (loading || loadingLocal)
    return (
      <>
        {contactoSoporteDialog}
        <AlertDialog
          title="Cargando local"
          content="Espere mientras se carga su local."
          open={loading || loadingLocal}
          hasActions={false}
        />
      </>
    )

  return (
    <>
      {contactoSoporteDialog}
      {local && <Navbar title={'Perfil del local'} />}
      <Container maxWidth="md">
        {isMobile ? (
          local && soloLectura ? (
            <SoloLectura
              local={local}
              setSoloLectura={setSoloLectura}
              getLocal={fetchData}
            />
          ) : (
            <FormLocales
              local={local}
              setSoloLectura={setSoloLectura}
              getLocal={fetchData}
              props={props}
              setLoading={setLoading}
              onShowContactoSoporte={handleShowContactoSoporte}
            />
          )
        ) : (
          <Paper variant="outlined" sx={{ px: { md: '3em', xs: '0.5em' } }}>
            {local && soloLectura ? (
              <SoloLectura
                local={local}
                setSoloLectura={setSoloLectura}
                getLocal={fetchData}
              />
            ) : (
              <FormLocales
                local={local}
                setSoloLectura={setSoloLectura}
                getLocal={fetchData}
                props={props}
                setLoading={setLoading}
                onShowContactoSoporte={handleShowContactoSoporte}
              />
            )}
          </Paper>
        )}
      </Container>
      <Footer />
    </>
  )
}

const mapStateToProps = (state: any) => {
  return {
    logged: state.logged,
    theme: state.theme,
    toaster: state.toaster,
    redirection: state.redirection
  }
}

const mapDispatchToProps = {
  // resetToaster,
  setRedirectUrl,
  setLogged
}

export default connect(mapStateToProps, mapDispatchToProps)(AbmLocalPage)
